import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appAutoGrow]'
})
export class AutoGrowDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event.target'])
  onInput(textArea: HTMLTextAreaElement): void {
    this.onlyGrow(textArea);
  }

  private onlyGrow(textArea: HTMLTextAreaElement): void {
    const h = textArea.offsetHeight;
    if (textArea.scrollHeight > h) {
      textArea.style.height = textArea.scrollHeight + 'px';
    }
  }
}
